import { useEffect, useState } from "react";
import { api } from "./api";
import { useSettings } from "../context/SettingsContext";

let cached = null;
let inflight = null;

export function loadUsdTry() {
  if (cached) return Promise.resolve(cached);
  if (!inflight) {
    inflight = api.get("/fx/usd-try")
      .then((r) => { cached = r.data.rate; return cached; })
      .catch(() => 0)
      .finally(() => { inflight = null; });
  }
  return inflight;
}

// Manual rate from Site Settings wins over the live market rate.
export function useUsdTry() {
  const { settings } = useSettings();
  const [live, setLive] = useState(cached || 0);
  useEffect(() => {
    let active = true;
    loadUsdTry().then((r) => active && setLive(r));
    return () => { active = false; };
  }, []);
  const manual = Number(String(settings?.usd_try_rate ?? "").replace(",", "."));
  return Number.isFinite(manual) && manual > 0 ? manual : live;
}

const formatTry = (amount) => `${(Math.round(amount / 10000) * 10000).toLocaleString("tr-TR")} ₺`;

// USD amounts in strings like "$95,000 – $150,000" become TRY amounts.
export function convertUsdToTry(text, rate) {
  const matches = String(text || "").match(/[\d][\d.,]*/g);
  if (!matches || !rate) return "";
  const parts = matches.map((m) => {
    const amount = Number(m.replace(/[.,](?=\d{3}\b)/g, "").replace(",", "."));
    return Number.isFinite(amount) ? formatTry(amount * rate) : null;
  }).filter(Boolean);
  return parts.length ? parts.join(" – ") : "";
}

/**
 * Turkish → manual TRY price when provided, otherwise auto-converted from USD.
 * Other languages → the USD price as entered.
 */
export function displayPrice(usdPrice, tryPrice, lang, rate) {
  if (lang !== "tr") return usdPrice || "";
  const manual = typeof tryPrice === "string" ? tryPrice.trim() : "";
  if (manual) return manual;
  if (!usdPrice) return "";
  return convertUsdToTry(usdPrice, rate) || usdPrice;
}
